import UserInfo from "./UserInfo/UserInfo";
import nexiLogo from "../../assets/logo-nexi-group.png";

import styles from "./HomePage.module.css";
import { Col, Row } from "react-bootstrap";
import HomePageButton from "./HomePageButton/HomePageButton";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ChecklistServicesApi, StatusServiceApi } from "../../service";
import LoadingPage from "../LoadingPage/LoadingPage";
import { isSuperuserValue, isStandardUserValue } from "../../access/access";

import { version as feVersion } from '../../../package.json';

const HomePage = (props) => {
  const [checklistsToEvaluate, setChecklistsToEvaluate] = useState();
  const [showNumberOfChecklists, setShowNumberOfChecklists] = useState(false);
  const [error, setError] = useState();

  const [isSuperuser, setIsSuperuser] = useState(isSuperuserValue());
  const [isStandardUser, setIsStandardUser] = useState(isStandardUserValue());
  const [powerBILink, setPowerBILink] = useState("");
  const [beVersion, setBeVersion] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const accountDetails = useSelector(state => state.accountDetails);

  console.log("isSuperUser: ", isSuperuser);
  console.log("isStandardUser: ", isStandardUser);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);

    let urlMainPath = window.location.href;
    if (urlMainPath.startsWith('https://ics.nexi')) { // production environment
      setPowerBILink('https://app.powerbi.com/groups/fffc5504-da3b-4a89-a657-5d9eddbbf0dc/reports/c77132f7-d069-4667-989d-721c33fdeca6/ReportSection');
    } else if(urlMainPath.startsWith('https://stgics.nexi')) { // staging environment
      setPowerBILink('https://app.powerbi.com/groups/fffc5504-da3b-4a89-a657-5d9eddbbf0dc/reports/38324b18-5133-4899-8259-e956be428f89/ReportSection');
    } else { // integration environment
      setPowerBILink('https://app.powerbi.com/groups/fffc5504-da3b-4a89-a657-5d9eddbbf0dc/reports/d63a2124-58d8-48cc-9994-ca94ff1d729d/ReportSection');
    }

    console.log("url main path: ", urlMainPath);

    setShowNumberOfChecklists(false);
    const checklistResourcesApi = new ChecklistServicesApi();
    checklistResourcesApi.getCountToEvaluate((error, data) => {
      if (mounted) {
        if (!error) {
          setChecklistsToEvaluate(data.message);
          setShowNumberOfChecklists(true);

          // VERSION REQUIREMENT API CALL -> The rest of the code related to this api is already written in the component, right now it is commented out

          const statusServicesApi = new StatusServiceApi();
          statusServicesApi.getBackendVersion((error, beV) => {
            if (mounted) {
              if (!error) {
                setBeVersion(beV);
                // setBeVersion(beV.split('-')[0]);
              } else {
                setError(() => {
                  throw new Error ("");
                })
              }
            }
          })
        } else {
          setError(() => {
            throw new Error ("");
          })
        }
      }
    });

    

    return () => { 
      mounted = false;
    }
  }, []);

  useEffect(() => {
    if (props.initialApiCallFinished !== 0) {
      console.log("initialApiCallFinished: ", props.initialApiCallFinished)
      setTimeout(() => { 
        setIsSuperuser(isSuperuserValue());        // \\ timeout probably needs to be removed with this solution
        setIsStandardUser(isStandardUserValue());  // // the text below refers to redux solution, which is not used
        // It seems that the component renders after the account api call is finished, but the redux state hasn't been updated yet. 
        //This function probably gives the component the necessary time to update the accountDetails from redux
        setIsLoading(false);
        console.log("set loading to false");
      },50)
    }
  }, [props.initialApiCallFinished]);

  const versionDisplayContainer = (
    <div className={styles.versionDisplayContainer}>
      <span>FE v{feVersion}, BE v{beVersion}</span>
    </div>
  )

  return (
    <div className="position-relative">
      {isLoading && <LoadingPage />}
      {!isLoading && beVersion && versionDisplayContainer}
      {!isLoading && <div className="py-3 px-3">
        <div className={`${styles.h_px_110} d-flex justify-content-between mb-3`}>
          <UserInfo accountDetails={accountDetails}></UserInfo>
          <img src={nexiLogo} className={`${styles.logo}`} alt="nexi-group" />
        </div>
        <Row>
          <Col className="d-flex flex-column">
            <p className="fw-bold mb-1">Checklist Management</p>
            <div className="hr mb-2"></div>
            <HomePageButton disabled={ !isSuperuser } toLink="/new-checklist">New Checklist</HomePageButton>
            <HomePageButton checklistsIndicator={showNumberOfChecklists} numberOfChecklists={checklistsToEvaluate} toLink="/checklist-monitor">Checklist Monitor</HomePageButton>
            <HomePageButton externalLink={powerBILink}>Reporting</HomePageButton>
            <HomePageButton toLink="/override-manager">Override</HomePageButton>
          
          </Col>
          <Col className="d-flex flex-column">
            <p className="fw-bold mb-1">Settings</p>
            <div className="hr mb-2"></div>
              <Col>
                <HomePageButton disabled={ !isSuperuser } toLink="/operational-area-monitor">Operational Area Management</HomePageButton>
                <HomePageButton disabled={ !isSuperuser } toLink="/company-monitor">Company Management</HomePageButton>
                <HomePageButton disabled={ !isSuperuser } toLink="/subsidiary-monitor">Subsidiary Management</HomePageButton>
                <HomePageButton disabled={ !isSuperuser } toLink="/template-monitor">Edit Framework's Questions</HomePageButton>
                <HomePageButton disabled={ !isSuperuser } toLink="/assessment-manager">Assessment Management</HomePageButton>
              </Col>
          </Col>
        </Row>
        <Row></Row>
      </div>}
    </div>
  );
};

export default HomePage;
